const PAINS = [
  { emoji: '📅', text: 'Missed soccer pick-ups because it was on someone else\'s calendar' },
  { emoji: '🛒', text: '"Can you grab milk?" texts that turn into forgotten items at checkout' },
  { emoji: '🍽️', text: 'Tuesday 5pm: "What\'s for dinner?" with nothing thawed' },
  { emoji: '🏠', text: 'Chores left undone because nobody knew whose turn it was' },
  { emoji: '💸', text: 'Subscriptions you forgot about bleeding the budget dry' },
  { emoji: '🔐', text: 'Wi-Fi password on a sticky note that fell behind the router' },
]

export const ProblemSection = () => (
  <section className="py-24 px-4 bg-[#1a1a2e] text-white">
    <div className="max-w-4xl mx-auto text-center">
      <p className="text-primary-light/70 text-sm font-semibold uppercase tracking-wider mb-4 reveal">Sound familiar?</p>
      <h2 className="font-display text-3xl sm:text-4xl font-bold mb-6 reveal">
        Running a household is a{' '}
        <span className="text-primary-light italic">full-time job.</span>
      </h2>
      <p className="text-white/60 text-base max-w-2xl mx-auto mb-14 reveal">
        Family life is chaotic. Between work, school, activities, and everything else,
        it's easy for things to slip through the cracks. DoorChart closes the gaps.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-left">
        {PAINS.map(({ emoji, text }, i) => (
          <div
            key={i}
            className="reveal flex items-start gap-3 bg-white/5 border border-white/10 rounded-2xl p-4"
            style={{ transitionDelay: `${i * 80}ms` }}
          >
            <span className="text-2xl flex-shrink-0">{emoji}</span>
            <p className="text-sm text-white/70 leading-relaxed">{text}</p>
          </div>
        ))}
      </div>

      <div className="mt-14 reveal">
        <p className="text-white/40 text-sm">There's a better way.</p>
        <div className="mt-3 inline-flex items-center gap-2 text-primary-light font-semibold text-lg">
          <span className="w-8 h-px bg-primary-light/40" />
          DoorChart
          <span className="w-8 h-px bg-primary-light/40" />
        </div>
      </div>
    </div>
  </section>
)
